export const formatDate = date => {
  return date == null || date === "0001-01-01T00:00:00"
    ? "-"
    : date
        .split("T")[0]
        .split("-")
        .reverse()
        .join("/");
};



// WEBPACK FOOTER //
// ./src/util/formatDate.ts